import React, { useState } from 'react';

import ReactTable from "react-table";
import { Button, Nav } from 'react-bootstrap';
import { TournamentConfig, TournamentStatus, TournamentSeason } from '../ReactProtos/Proto/dcei_wildsky_tournament_proto';
import { EditorBase } from './EditorBase';
import Datetime from 'react-datetime';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import Switch from '@material-ui/core/Switch';
import { FieldDescriptor } from '../ReactProtos/Helper/Descriptor';

import 'react-table/react-table.css';

import './custom.scss';

const FlexDiv = (props) => (
    <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        {props.children}
    </div>
);

const PadDiv = (props) => (
    <div style={{ padding: '12px' }}>
        {props.children}
    </div>
);

const snakeToCamel = (string) => {
    return string.replace(/(_\w)/g, function (m) {
        return m[1].toUpperCase();
    });
};

const docToProto = (proto) => {
    if (Array.isArray(proto)) {
        let output = [];
        proto.forEach(value => {
            output.push(docToProto(value));
        });
        return output;
    } else {
        let output = {};
        Object.keys(proto).forEach(key => {
            let newKey = snakeToCamel(key);
            console.assert(!output.hasOwnProperty(newKey));
            let value = proto[key];
            if (typeof (value) == "object" && value !== null) {
                output[newKey] = docToProto(proto[key]);
            } else {
                output[newKey] = value;
            }
        });
        return output;
    }
};

const toJsonWithExplicitDefaults = (proto) => {
    const jsonObject = {};
    for (let field of proto.descriptor.fields) {
        if (field.isMap) {
            const values = proto[field.name];
            const mapField = {};
            for (let key in values) {
                if (field.valueProtoType == FieldDescriptor.TYPE_MESSAGE) {
                    mapField[key] = toJsonWithExplicitDefaults(values[key])
                }
                else {
                    mapField[key] = values[key]
                }
            }
            jsonObject[field.name] = mapField;
        }
        else if (field.isRepeated) {
            const values = proto[field.name];
            const repeatedField = [];
            for (let i = 0; i < values.length; i++) {
                if (field.protoType === FieldDescriptor.TYPE_MESSAGE) {
                    repeatedField.push(toJsonWithExplicitDefaults(values[i]))
                }
                else {
                    repeatedField.push(values[i])
                }
            }
            jsonObject[field.name] = repeatedField;
        }
        else if (field.protoType === FieldDescriptor.TYPE_MESSAGE) {
            jsonObject[field.name] = toJsonWithExplicitDefaults(proto[field.name]);
        }
        else {
            jsonObject[field.name] = proto.selfValue[field.name];
        }
    }
    return jsonObject;
}

function TournamentActionView(props) {
    function duplicate(e) {
        e.stopPropagation();
        fetch('/api/data/tournament/duplicate', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: props.tournament_id
            }),
        }).then(() => {
            props.onUpdate();
        });
    }
    return (<div>
        <Button onClick={(e) => duplicate(e)}>Duplicate</Button>
    </div>);
}

TournamentActionView.propTypes = {
    tournament_id: PropTypes.string.isRequired,
    onUpdate: PropTypes.func.isRequired,
};

function TournamentTableColumns(onUpdate) {
    return [
        {
            accessor: row => row.config.name,
            Header: "Tournament Name",
            sortable: false,
            id: 'name'
        },
        {
            id: 'map',
            Header: 'Map',
            accessor: row => row.config.map,
        },
        {
            accessor: row => new Date(row.start_time).toLocaleString(),
            Header: "Start Time",
            sortable: true,
            id: 'start_time'
        },
        {
            accessor: row => new Date(row.end_time).toLocaleString(),
            Header: "End Time",
            sortable: true,
            id: 'end_time'
        },
        {
            accessor: row => TournamentStatus.names[row.status],
            id: 'status',
            Header: "Status",
            sortable: true,
        },
        {
            accessor: row => row.config.season,
            id: 'season',
            Header: "Season",
            sortable: true,
        },
        {
            // eslint-disable-next-line react/display-name
            accessor: row => <TournamentActionView tournament_id={row._id} onUpdate={onUpdate} />,
            id: 'actions',
            Header: "Actions",
        }
    ];
}

function DeckView(props) {
    const [showDetail, setShowDetail] = useState(false);
    return (<div>
        {
            showDetail &&
            <div>
                <Button onClick={() => setShowDetail(false)}>Less</Button>
                <pre>
                    {JSON.stringify(props.deck, null, 4)}
                </pre>
            </div>
        }
        {
            !showDetail &&
            <div>
                <pre>
                    {JSON.stringify(props.deck.cards.map(c => [c.name, c.level]))}
                    <Button onClick={() => setShowDetail(true)}>More</Button>
                </pre>
            </div>
        }
    </div>);
}

DeckView.propTypes = {
    deck: PropTypes.object.isRequired,
};

function BanView(props) {
    function ban(value) {
        fetch('/api/data/user/tournament_ban', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                uuid: props.uuid,
                tournament_id: props.tournament_id,
                banned: value,
            }),
        }).then(() => {
            props.onUpdate();
        });
    }
    if (props.banned) {
        return (<div>
            true&nbsp;
            <Button onClick={() => ban(false)}>Unban</Button>
        </div>);
    }
    return (<div>
        false&nbsp;
        <Button onClick={() => ban(true)}>Ban</Button>
    </div>);
}

BanView.propTypes = {
    uuid: PropTypes.string.isRequired,
    tournament_id: PropTypes.string.isRequired,
    banned: PropTypes.bool.isRequired,
    onUpdate: PropTypes.func.isRequired,
};


function RankView(props) {
    function resetRank() {
        fetch('/api/data/user/set_tournament_rank', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                uuid: props.uuid,
                tournament_id: props.tournament_id,
                rank: 0,
            }),
        }).then(() => {
            props.onUpdate();
        });
    }
    return (<div>
        {props.rank}&nbsp;
        <Button onClick={resetRank}>Reset</Button>
    </div>);
}

RankView.propTypes = {
    uuid: PropTypes.string.isRequired,
    tournament_id: PropTypes.string.isRequired,
    rank: PropTypes.number.isRequired,
    onUpdate: PropTypes.func.isRequired,
};

function PlayerTableColumns(onUpdate) {
    return [
        {
            id: "name",
            Header: "Name",
            // eslint-disable-next-line react/display-name
            Cell: prop => <a href={`/user/${prop.original.uuid}`} target="_blank" rel="noopener noreferrer">{prop.row.name}</a>,
            width: 150,
            accessor: 'name'
        },
        {
            id: "banned",
            // eslint-disable-next-line react/display-name
            accessor: row => <BanView uuid={row.uuid} tournament_id={row.tournament_id} banned={row.banned} onUpdate={onUpdate} />,
            Header: "banned",
            width: 150,
        },
        {
            accessor: "score",
            Header: "Score",
            width: 100,
        },
        {
            id: "rank",
            Header: "Rank",
            width: 150,
            // eslint-disable-next-line react/display-name
            accessor: row => <RankView uuid={row.uuid} tournament_id={row.tournament_id} rank={row.rank} onUpdate={onUpdate} />,
        },
        {
            accessor: 'group_index',
            Header: "Group Index",
            width: 100,
        },
        {
            accessor: 'league',
            Header: "League",
            width: 100,
        },
        {
            accessor: 'next_league',
            Header: "Next League",
            width: 100,
        },
        {
            accessor: row => row.attempts.length,
            Header: "Attempts",
            width: 100,
            id: 'attempts',
        },
        {
            // eslint-disable-next-line react/display-name
            accessor: row => <DeckView deck={row.deck} />,
            Header: "Deck",
            id: 'deck'
        }
    ];
}

class DateTimeEditor extends React.PureComponent {
    onChange = date => {
        if (typeof (date) == "object") {
            this.props.onChange(Math.floor(date.toDate().getTime() / 1000 + 7 *3600));
        }
    }

    render() {
        return (
            <div>
                <Datetime utc = {true} value={new Date((this.props.value -7 *3600) * 1000)} onChange={this.onChange} />
            </div>
        );
    }
}

TournamentConfig.descriptor.fields.find(f => f.name === 'startTime').customEditor = DateTimeEditor;
TournamentConfig.descriptor.fields.find(f => f.name === 'endTime').customEditor = DateTimeEditor;
TournamentSeason.descriptor.fields.find(f => f.name === 'startTime').customEditor = DateTimeEditor;
TournamentSeason.descriptor.fields.find(f => f.name === 'endTime').customEditor = DateTimeEditor;

class BooleanEditor extends React.PureComponent {
    onChange = e => {
        this.props.onChange(e.target.checked);
    }

    render() {
        return (
            <Switch checked={this.props.value} onChange={e => this.onChange(e)} color="primary" />
        )
    }
}

TournamentSeason.descriptor.fields.find(f => f.name === 'finished').customEditor = BooleanEditor;

function createTournamentConfigFromResponse(data) {
    let config = docToProto(data.config);
    // backward compatibility
    config.startTime = Math.floor(new Date(data.start_time).getTime() / 1000);
    config.endTime = Math.floor(new Date(data.end_time).getTime() / 1000);

    return new TournamentConfig.WithParent(TournamentConfig.fromJson(config), null);
}

function createTournamentSeasonFromResponse(data) {
    let d = docToProto(data);
    // backward compatibility
    d.startTime = Math.floor(new Date(data.start_time).getTime() / 1000);
    d.endTime = Math.floor(new Date(data.end_time).getTime() / 1000);
    d.finished = data.finished;

    return new TournamentSeason.WithParent(TournamentSeason.fromJson(d), null);
}

class TournamentTab extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selected: null,
            data: [],
            addNew: false,
            config: null,
        };
    }

    componentDidMount() {
        this.query();
    }

    getTdProps = (_, rowInfo) => {
        return {
            style: {
                cursor: 'pointer',
                background: this.state.selected == rowInfo.original._id ? "gold" : null,
            },
            onClick: () => {
                const selected = rowInfo.original._id;
                const d = this.state.data.filter(x => x._id == selected)[0];
                this.setState({
                    selected: selected,
                    config: createTournamentConfigFromResponse(d),
                    status: d.status,
                });
            }
        };
    }

    deselect() {
        this.setState({ selected: null, addNew: false });
    }

    onConfigChange = (value) => {
        this.setState({
            config: value
        });
    }

    onStatusChange = () => {
        this.setState({
            status: (this.state.status + 1) % 6
        });
    }

    create() {
        this.setState({
            selected: null,
            addNew: true,
            config: TournamentConfig.WithParent.default,
            status: 4
        });
    }

    query() {
        fetch(`/api/data/search/tournament`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ query: {}, sort: { start_time: -1 } }),
        })
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ error: result.error });
                } else {
                    this.setState({ data: result.results });
                }
            });
    }

    save = () => {
        fetch(`/api/data/tournament`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: this.state.selected,
                status: this.state.status,
                config: eval(toJsonWithExplicitDefaults(this.state.config)),
            }),
        })
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ error: result.error });
                } else {
                    this.setState({
                        selected: null,
                        addNew: false,
                        config: null,
                    });
                    this.query();
                }
            });
    }

    handleTextField = name => event => {
        this.setState({ [name]: event.target.value });
    }

    render() {
        const { selected, addNew, data, config, status } = this.state;

        if (selected || addNew) {
            return (
                <FlexDiv>
                    <PadDiv>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="#" onClick={() => this.deselect()}>Tournament</a></li>
                                <li className="breadcrumb-item active" aria-current="page">{selected ? selected : 'New'}</li>
                            </ol>
                        </nav>
                        <Button variant="danger" className="mr-2" onClick={() => this.save()}>Save</Button>
                        <Button variant="warning" onClick={() => this.deselect()}>Cancel</Button>
                        <div className="mt-2">
                            <label className="mr-2">Status</label>
                            <Button variant={status == 4 ? "primary" : "danger"} onClick={() => this.onStatusChange()}>{TournamentStatus.names[status]}</Button>
                        </div>
                    </PadDiv>
                    <EditorBase name="Tournament Editor" proto={TournamentConfig} data={config} onChange={(e) => this.onConfigChange(e)} />
                </FlexDiv>
            );
        } else {
            return (
                <PadDiv>
                    <Button variant="primary" onClick={() => this.create()}>Create</Button>
                    <ReactTable
                        className="-striped -highlight"
                        columns={TournamentTableColumns(() => this.query())}
                        pageSize={data.length}
                        showPagination={false}
                        getTdProps={this.getTdProps}
                        data={data}
                    />
                </PadDiv>
            );
        }
    }
}

class PlayerTab extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            selected: null,
            tournament_id: '',
            uuid: '',
            group_index: '',
            league: '',
        };
    }

    handleTextField = name => event => {
        this.setState({ [name]: event.target.value });
    }

    onSearchUuid = () => {
        if (this.state.uuid) {
            this.query({
                uuid: this.state.uuid
            });
        }
    }

    onSearchPlayers = () => {
        let term = {
            tournament_name: this.state.tournament_id
        };
        if (this.state.group_index !== '') {
            term.group_index = parseInt(this.state.group_index);
        }
        if (this.state.league !== '') {
            term.league = parseInt(this.state.league);
        }
        this.query(term);
    }

    query(term) {
        fetch(`/api/data/search/tournament_players`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ query: term, sort: { score: -1 } }),
        })
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ error: result.error });
                } else {
                    this.setState({ data: result.results });
                }
            });
    }

    render() {
        const { data, uuid, tournament_id, group_index, league } = this.state;
        return (
            <PadDiv>
                <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'row' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                        <TextField label="User Id" value={uuid} onChange={this.handleTextField('uuid')} />
                        <Button variant="primary" className="mt-2" disabled={!uuid} onClick={() => this.onSearchUuid()}>Search UUID</Button>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '10px', flexGrow: 1 }}>
                        <TextField label="Tournament Name" value={tournament_id} onChange={this.handleTextField('tournament_id')} />
                        <TextField label="Group Index" className="mt-2" value={group_index} type="number" onChange={this.handleTextField('group_index')} />
                        <TextField label="League" className="mt-2" value={league} type="number" onChange={this.handleTextField('league')} />
                        <Button variant="primary" className="mt-2" disabled={!tournament_id} onClick={() => this.onSearchPlayers()}>Search Players</Button>
                    </div>
                </div>
                {data && data.length > 0 &&
                    <PadDiv>
                        <ReactTable
                            className="-striped -highlight"
                            columns={PlayerTableColumns(() => this.onSearchPlayers())}
                            pageSize={data.length}
                            showPagination={false}
                            data={data}
                        />
                    </PadDiv>
                }
            </PadDiv>
        );
    }
}

function TournamentSeasonTableColumns() {
    return [
        {
            Header: "Season",
            sortable: false,
            accessor: 'season'
        },
        {
            accessor: row => new Date(row.start_time).toLocaleString(),
            Header: "Start Time",
            sortable: true,
            id: 'start_time'
        },
        {
            accessor: row => new Date(row.end_time).toLocaleString(),
            Header: "End Time",
            sortable: true,
            id: 'end_time'
        },
        {
            accessor: row => row.finished ? "true" : "false",
            Header: "Finished",
            sortable: true,
            id: "finished",
        },
        {
            accessor: 'highest_league',
            Header: "Highest League",
            sortable: true,
        },
        {
            accessor: 'rank_count',
            Header: "Rank Count",
            sortable: true,
        }
    ];
}
class SeasonTab extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: null,
            data: [],
            addNew: false,
            selectedData: null,
        };
    }

    componentDidMount() {
        this.query();
    }

    getTdProps = (_, rowInfo) => {
        return {
            style: {
                cursor: 'pointer',
                background: this.state.selected == rowInfo.original._id ? "gold" : null,
            },
            onClick: () => {
                const selected = rowInfo.original._id;
                const d = this.state.data.filter(x => x._id == selected)[0];
                this.setState({
                    selected: selected,
                    selectedData: createTournamentSeasonFromResponse(d),
                });
            }
        };
    }

    query() {
        fetch(`/api/data/search/tournament_season`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ query: {}, sort: { start_time: -1 } }),
        })
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ error: result.error });
                } else {
                    this.setState({ data: result.results });
                }
            });
    }

    create() {
        this.setState({
            selected: null,
            addNew: true,
            selectedData: TournamentSeason.WithParent.default,
        });
    }

    onSelectedDataChange = (value) => {
        this.setState({
            selectedData: value
        });
    }

    deselect() {
        this.setState({ selected: null, addNew: false, selectedData: null });
    }

    save = () => {
        console.log(this.state.selectedData);
        fetch(`/api/data/tournament/season`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: this.state.selected,
                data: eval(toJsonWithExplicitDefaults(this.state.selectedData)),
            }),
        })
            .then(response => response.json())
            .then(result => {
                if (result.error) {
                    this.setState({ error: result.error });
                } else {
                    this.setState({
                        selected: null,
                        addNew: false,
                        selectedData: null,
                    });
                    this.query();
                }
            });
    }

    render() {
        const { selected, addNew, data, selectedData } = this.state;
        console.log(selectedData);
        if (selected || addNew) {
            return (
                <FlexDiv>
                    <PadDiv>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><a href="#" onClick={() => this.deselect()}>Season</a></li>
                                <li className="breadcrumb-item active" aria-current="page">{selected ? selected : 'New'}</li>
                            </ol>
                        </nav>
                        <Button variant="danger" className="mr-2" onClick={() => this.save()}>Save</Button>
                        <Button variant="warning" onClick={() => this.deselect()}>Cancel</Button>
                    </PadDiv>
                    <EditorBase name="Tournament Season Editor" proto={TournamentSeason} data={selectedData} onChange={(e) => this.onSelectedDataChange(e)} />
                </FlexDiv>
            );
        } else {
            return (
                <PadDiv>
                    <Button variant="primary" onClick={() => this.create()}>Create</Button>
                    <ReactTable
                        className="-striped -highlight"
                        columns={TournamentSeasonTableColumns()}
                        pageSize={data.length}
                        showPagination={false}
                        getTdProps={this.getTdProps}
                        data={data}
                    />
                </PadDiv>
            );
        }
    }
}


export class TournamentEditor extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const tab = this.props.location.pathname;
        return (
            <FlexDiv>
                <Nav variant="pills" activeKey={tab}>
                    <Nav.Item>
                        <Nav.Link eventKey="/tournament" href="/tournament">Tournament</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/tournament/players" href="/tournament/players">Players</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey="/tournament/season" href="/tournament/season">Season</Nav.Link>
                    </Nav.Item>
                </Nav>

                {tab == "/tournament" &&
                    <TournamentTab {...this.props} />
                }
                {tab == "/tournament/players" &&
                    <PlayerTab {...this.props} />
                }
                {tab == "/tournament/season" &&
                    <SeasonTab {...this.props} />
                }
            </FlexDiv>
        );
    }
}
